import { render, staticRenderFns } from "./SubjectUpload.vue?vue&type=template&id=17dadac0&"
import script from "./SubjectUpload.vue?vue&type=script&lang=ts&"
export * from "./SubjectUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports